exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Ehd79Tfm8By5OoLW_OLPk{font-size:11px}html[dir] .TqFsCgPj6r4xXjvFZc-UO{background-color:unset!important}", ""]);
// Exports
exports.locals = {
	"roomSecondaryText": "_2Ehd79Tfm8By5OoLW_OLPk",
	"roomSecondaryCapabilityIcon": "TqFsCgPj6r4xXjvFZc-UO"
};